import { useMemo } from 'react'

import { useSessionStore } from '@/stores/useSessionStore'
import type { BaseOverrides } from '@/types'
import { cssNum } from '@/utils'
import { DefaultBrandStyle } from '@/utils/styles'

export function useBaseOverrides() {
  const widgetStyle = useSessionStore((state) => state.widgetSettings?.style)

  const baseOverrides: BaseOverrides & {
    surfacePrimaryColor?: string
    surfaceSecondaryColor?: string
  } = useMemo(
    () => ({
      brandColor: widgetStyle?.brandColor ?? DefaultBrandStyle?.brandColor,
      dangerColor: widgetStyle?.dangerColor ?? DefaultBrandStyle?.dangerColor,
      successColor: widgetStyle?.successColor ?? DefaultBrandStyle?.successColor,
      textPrimaryColor: widgetStyle?.textPrimary ?? DefaultBrandStyle?.textPrimary,
      textSecondaryColor: widgetStyle?.textSecondary ?? DefaultBrandStyle?.textSecondary,
      borderColor: widgetStyle?.borderPrimary ?? DefaultBrandStyle?.borderPrimary,
      borderRadius: cssNum(
        widgetStyle?.input?.borderRadius?.topLeft ?? DefaultBrandStyle?.input?.borderRadius?.topLeft
      ),
      surfacePrimaryColor: widgetStyle?.surfacePrimary ?? DefaultBrandStyle?.surfacePrimary,
      surfaceSecondaryColor: widgetStyle?.surfaceSecondary ?? DefaultBrandStyle?.surfaceSecondary,
    }),
    [widgetStyle]
  )

  return baseOverrides
}
